import Typography from '~/components/Typography.tsx';
import useSomeDayCutOff from '../pages/home/hooks/useSomeDayCutOff.ts';
import { useKintStore } from '~kint/store';
import dayjs from 'dayjs';

export default function OnTourCouponTimeLimit() {
  const { reservation } = useKintStore((state) => ({
    reservation: state.reservation,
  }));
  const { cutOffRemains } = useSomeDayCutOff(dayjs(reservation?.date).toDate());
  return (
    <Typography
      variant="BaseL_B"
      color={'primary.main'}
      sx={{
        height: '48px',
        borderRadius: '24px',
        fontWeight: 700,
        border: 'solid 1px',
        display: 'flex',
        alignItems: 'center',
        padding: '16px',
      }}
    >
      TIME LIMIT {cutOffRemains.text}
    </Typography>
  );
}
